import React from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";

class WordpressDropdown extends React.Component {
  state = {
    isDroppedDown: false,
  };

  constructor(props) {
    super(props);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  toggleDropdown(e) {
    e.preventDefault();
    this.setState({
      isDroppedDown: !this.state.isDroppedDown,
    });
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside, true);
  }

  handleClickOutside = (e) => {
    const domNode = ReactDOM.findDOMNode(this);
    if (!domNode || !domNode.contains(e.target)) {
      this.setState({
        isDroppedDown: false,
      });
    }
  };

  render() {
    let dropdownClass = classNames({
      dropdown: true,
      "dropdown--is-visible": this.state.isDroppedDown,
    });
    return (
      <li className="main-apps__app-icon" ref={(node) => (this.node = node)}>
        <button
          target="_blank"
          rel="noopener noreferrer"
          alt="app"
          onClick={this.toggleDropdown}
          className="app-icon app-icon-wordpress"
        >
          <img
            alt="wordpress icon"
            src="https://cdn.realsmart.co.uk/new-cpanel/wordpress_icon.png"
            className="app-icon app-icon-wordpress"
          />
        </button>
        {typeof this.props.school !== "undefined" &&
          this.props.school.sc_wordpress_url !== "" && (
            <ul id="wordpress-dropdown" className={dropdownClass}>
              <li className="wordpress-dropdown--item">
                <a
                  href={
                    this.props.school.sc_wordpress_url +
                    (this.props.wordpress === 4 ? "/wordpress" : "") +
                    "/wp-admin"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  alt="app"
                  className=""
                >
                  <img
                    alt="wordpress dashboard"
                    src="https://cdn.realsmart.co.uk/new-cpanel/wordpress_icon.png"
                    className="app-icon app-icon-gmail"
                  />
                  <span>Dashboard</span>
                </a>
              </li>
              <li className="wordpress-dropdown--item">
                <a
                  href={
                    this.props.school.sc_wordpress_url +
                    (this.props.wordpress === 4 ? "/wordpress" : "") +
                    "/wp-admin/post-new.php"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  alt="app"
                  className=""
                >
                  <img
                    alt="wordpress add a post"
                    src="https://cdn.realsmart.co.uk/new-cpanel/wordpress_icon.png"
                    className="app-icon app-icon-gmail"
                  />
                  <span>Add a post</span>
                </a>
              </li>
              <li className="wordpress-dropdown--item">
                <a
                  href={
                    this.props.school.sc_wordpress_url +
                    (this.props.wordpress === 4 ? "/wordpress" : "") +
                    "/wp-admin/post-new.php?post_type=page"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  alt="app"
                  className=""
                >
                  <img
                    alt="wordpress add a page"
                    src="https://cdn.realsmart.co.uk/new-cpanel/wordpress_icon.png"
                    className="app-icon app-icon-gmail"
                  />
                  <span>Add a page</span>
                </a>
              </li>
            </ul>
          )}
      </li>
    );
  }
}

export default WordpressDropdown;
